"use strict";

var angular = require("angular");
var angularLocalStorage = require("angular-local-storage");
var $ = jQuery = require("jquery");
var jQueryTrusive = require("jquery-trusive");
var jQueryValidate = require("jquery-validate");
var jQueryValidateTrusive = require("jquery-validate-trusive");

var app = angular.module("registration", ["LocalStorageModule"]);
app.config([
    "localStorageServiceProvider",
    function (localStorageServiceProvider) {
        localStorageServiceProvider.setStorageType('sessionStorage');
    }
]);

var jobApplicationFormDirective = {};

app.controller("registration.RegistrationController", [
    "$scope", "localStorageService",
    function ($scope, storage) {
        var controller = this;
        var initModel, persistedModel;
        var storageId;
        var modelWatch = $scope.$watch("model", function(newValue, oldValue){
            if (newValue && newValue.pageId) {
                storageId = "registrationModel_" + newValue.pageId;
            }
            if (newValue && newValue.state === "init") {
                initModel = newValue;
                persistedModel = storage.get(storageId);
                if (persistedModel) {
                    $scope.model = persistedModel;
                } else {
                    $scope.model.state = "started";
                }
            }
            if (newValue && newValue.state !== "init") {
                controller.persist(storageId, newValue);
            }
        }, /*objectEquality =*/ true);

        controller.validate = function (step) {
            var correct = 0;
            angular.forEach($scope.model.form[step].questions, function (q) {
                if (q.checked === q.value) {
                    correct++;
                }
            });
            return correct === $scope.model.form[step].questions.length;
        };
        controller.next = function () {
            if (controller.validate($scope.model.currentStep)) {
                $scope.model.state = "started";
                $scope.model.currentStep++;
            } else {
                $scope.model.state = "invalid";
            }
        };
        controller.prev = function () {
            $scope.model.state = "started";
            $scope.model.currentStep--;
        };
        controller.complete = function (completedUrl) {
            $scope.model.state = "complete";
            storage.remove(storageId);
            modelWatch(); //stop watching model changes
            window.location = completedUrl;
        };
        controller.persist = function (key, value) {
            storage.set(key, value);
        };

        $scope.controller = controller;
        $scope.registration = {};
        $scope.$on("$destroy", function(){
            modelWatch(); //stop watching model changes
        });
    }
]);

app.directive("registrationCbl", [
    function () {
        function link(scope, element, attrs) {
        }
        return {
            restrict: "E",
            link: link,
            template: require("assets_src/html/registration.cbl.html")
        };
    }
]);

app.directive("registrationStep", [
    function () {
        function link(scope, element, attrs) {
            var currentStep = parseInt(attrs.registrationStep);
            scope.current = {
                step: currentStep,
                type: scope.model.form[currentStep].type
            };
        }
        return {
            restrict: "A",
            scope: true,
            link: link
        };
    }
]);

app.directive("filterSelectric", [
    function() {
        return {
            scope: {
                selectric: "@filterSelectric"
            },
            restrict: 'A',
            link: function(scope, element, attrs) {
                jQuery(element).selectric({
                    maxHeight: 200,
                    responsive: true,
                    disableOnMobile: false
                });
            }
        };
    }
]);

app.directive("jobApplicationForm", [
    "$compile",
    function($compile) {
        jobApplicationFormDirective.$compile = $compile;
        jobApplicationFormDirective.recompile = function(element) {
            jobApplicationFormDirective.$compile(element.contents())(element.scope())
        };

        return {
            scope: true,
            restrict: 'A',
            link: function(scope, element, attrs) {
            }
        };
    }
]);

var registration = {
    JobApplication_OnSuccess: function (r) {
        var element = $("#JobApplication_response");
        jobApplicationFormDirective.recompile(element);
    },
    JobApplication_OnFailure: function (r) {
        var element = $("#JobApplication_response");
        jobApplicationFormDirective.recompile(element);
    }
};

module.exports = registration;


/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/js/angular.registration.js
 ** module id = 8
 ** module chunks = 0
 **/